var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"overflow-hidden"},[_c('AppBar'),_c('v-main',{attrs:{"id":"scrolling_screen"}},[_c('router-view')],1),_c('div',{directives:[{name:"rellax",rawName:"v-rellax",value:({ speed: 4.5 }),expression:"{ speed: 4.5 }"}],staticClass:"parallaxeForm1",style:({
      backgroundImage: `url(${require('@/assets/icos/Ellipse-moyenne.png')})`
    })}),_c('div',{directives:[{name:"rellax",rawName:"v-rellax",value:({ speed: 4.5 }),expression:"{ speed: 4.5 }"}],staticClass:"parallaxeForm2",style:({
      backgroundImage: `url(${require('@/assets/icos/big-heart.png')})`
    })}),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }